import { PageSectionsContentSectionContentBlocksPricingCards, PageSectionsContentSectionContentBlocksPricingCardsPriceCard } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import { a11y } from '../styles/a11y';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { Action, ActionButtons } from './Buttons/ActionButtons';
import { RichText } from './RichText';
import { CircleCheck } from './svg/ui-icons';
export interface PriceListProps {
  data: PageSectionsContentSectionContentBlocksPricingCards;
}
export interface PriceCardProps {
  data: PageSectionsContentSectionContentBlocksPricingCardsPriceCard;
}
export function PriceList({
  data
}: PriceListProps) {
  return data ? <ol className="x1ghz6dp x1717udv x1mhrlx8 xe8uvvx xuk3077 x78zum5 x1a02dak">
      {data.priceCard.map((price, i) => {
      const key = `${i}-${price.tierName.split(' ').join('-')}`;
      return <PriceCard data={price} key={key} />;
    })}
    </ol> : null;
}
export function PriceCard({
  data,
  ...props
}: PriceCardProps) {
  return data ? <li {...stylex.props([layout.contentCard, cardStyles.priceCard])} {...props}>
      <article className="x16pmaob x1cpgip3 x6cetg1 xrvj5dj x1bpjty1">
        <div className="x9nponh x13v2zrn x1p26ff5 x1te3hdz xeq5yr9">
          <h1 {...stylex.props([typography.heading2])} data-tina-field={tinaField(data, 'tierName')}>
            {data.tierName}
          </h1>
          <h2 {...stylex.props([typography.body])} data-tina-field={tinaField(data, 'tierSubheading')}>
            {data.tierSubheading}
          </h2>
        </div>
        <RichText wrapperStyles={cardStyles.description} data-tina-field={tinaField(data, 'description')}>
          {data.description}
        </RichText>
        <p className="x1xyzvbz xmanbdr x11cx04x x122p1ho">
          {data.pricePrefix && <>
              <span {...stylex.props([typography.small])} data-tina-field={tinaField(data, 'pricePrefix')}>
                {data.pricePrefix}
              </span>
              <br />
            </>}
          <span {...stylex.props([typography.heading1])} data-tina-field={tinaField(data, 'price')}>
            {data.price}
          </span>
          {data.priceSuffix && <>
              <br />
              <span {...stylex.props([typography.small])} data-tina-field={tinaField(data, 'priceSuffix')}>
                {data.priceSuffix}
              </span>
            </>}
        </p>
        {data.tierInclusions && <>
            <p {...stylex.props([a11y.visuallyHidden])}>Including:</p>
            <ul className="x1ghz6dp x1717udv xe8uvvx xatt29v xhbc04i x164iwpj xjc85lq" data-tina-field={tinaField(data, 'tierInclusions')}>
              {data.tierInclusions?.map((inc, i) => <li {...stylex.props([typography.body, cardStyles.listItem])} key={`${i}-${inc?.split(' ').join('-')}`}>
                  <CircleCheck className="x1c4vz4f x2lah0s xlup9mm x1kky2od" role="presentation" key={`${i}-${inc?.split(' ').join('-')}-icon`} />
                  <span key={`${i}-${inc?.split(' ').join('-')}-text`}>
                    {inc}
                  </span>
                </li>)}
            </ul>
          </>}
        <div className="x1qjc9v5 x7fd4wk x78zum5 xdt5ytf xrh9943 x7sznat x36isyd x1pgfpwx">
          {data.ctaButton && <ActionButtons actions={[data.ctaButton] as Action[]} args={{
          componentName: data.__typename
        }} />}
        </div>
      </article>
    </li> : null;
}
const cardStyles = {
  description: {
    kWZpDQ: "x1w272jb",
    kEXP64: "x3telbv",
    kpJH7q: "x1fwlwh1",
    k1lYIM: "x8adoir",
    kN2L0X: "x1fzhlzt",
    ks0D6T: "x1oc4otl",
    $$css: true
  },
  listItem: {
    kOIVth: "x16pmaob",
    k8WAf4: "x1tqsu7c",
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    $$css: true
  },
  priceCard: {
    k9g6sI: "x12h1iku",
    kCS8Yb: "x1t1x2f9",
    kzQI83: "x1iyjqo2",
    kmuXW: "xs83m0k",
    k7Eaqz: "xihn3vw",
    $$css: true
  }
};